export default "__VITE_ASSET__9ytW1EwO__"